export default __webpack_public_path__ + "static/media/settings_mobile-category.4af7a43d.svg";